import React from "react";
import styles from "../../../views/DetailMDR/DetailMDR.module.css";
import ReferenceScoreRange from "../../ReferenceScoreRange/ReferenceScoreRange";
import "../../ReferenceScoreRange/ReferenceScoreRange.css";
import NotReportViewData from "../../NotReportViewData/NotReportView";
import { FcStatistics } from "react-icons/fc";

const TableMDRCompany = ({ data }) => {
  const riskColors = {
    1: "#5fbf49",
    2: "#f6e502",
    3: "#f49e01",
    4: "#ff7089",
    5: "red",
  };

  // Predefinir los valores para "Factor de riesgo" y "Variable"
  const combinedValues = data
    ? [
        {
          factorRiesgo: "Ingresos Legales",
          variable: "Monto Transaccional Anual",
          valorObtenido: data.EconomicInformationCompany.IncomeOfLegalPerson,
          riesgoObtenido: data.MDRCompany.IncomeLegal.value,
        },
        {
          factorRiesgo: "Ubicacion - Zona Geografica",
          variable: "Codigo Postal - Localidad",
          valorObtenido: data.postalCode + " " + data.location,
          riesgoObtenido: data.MDRCompany.GeographicLocation.value,
        },
        {
          factorRiesgo: "Actividad que desarrolla",
          variable: "Actividades AFIP",
          valorObtenido: data.ActivityBeingCarriedOut,
          riesgoObtenido: data.MDRCompany.ActivityBeingCarriedOut.value,
        },
        {
          factorRiesgo: "Antigüedad en la actividad",
          variable: "En REPSAL",
          valorObtenido: data.age + " años",
          riesgoObtenido: data.MDRCompany.ActivitySeniority.value,
        },
        {
          factorRiesgo: "Tipo de operatoria",
          variable: "En REPSAL",
          valorObtenido: data.RelationshipWithMutualCompany.typeOfCredit,
          riesgoObtenido: data.MDRCompany.TypeOperation.value,
        },
        {
          factorRiesgo: "Tipo de cliente",
          variable: "Persona Humana o Jurídica",
          valorObtenido: data.typeCustomer,
          riesgoObtenido: data.MDRCompany.TypeCustomer.value,
        },
        {
          factorRiesgo: "Presentación de documentación",
          variable: "Documentación",
          valorObtenido: data.MDRCompany.Documentation.data,
          riesgoObtenido: data.MDRCompany.Documentation.value,
        },
        {
          factorRiesgo: "Canal",
          variable: "Físico o Digital",
          valorObtenido: data.MDRCompany.Canal.data,
          riesgoObtenido: data.MDRCompany.Canal.value,
        },
      ]
    : [];

  return (
    <div className={styles.Lealtadbody}>
      {data === null ? (
        <NotReportViewData title="Matriz de riesgo" Icon={FcStatistics} />
      ) : (
        <>
          <div className={styles.LealtadbodyTitle}>
            <p>Detalle de la Matriz de Riesgo</p>
          </div>
          <div className={styles.LealtadbodySubtitle}>
            <p>Nombre de la Matriz:</p>{" "}
            <p style={{ color: "#56b599", fontSize: "16px" }}>
              MDR configuración Básica {data.typeCustomer}
            </p>
          </div>
          <ReferenceScoreRange />
          <table className={styles.Lealtadtable}>
            <thead>
              <tr>
                <th>Factor de riesgo</th>
                <th>Variable</th>
                <th>Valor obtenido</th>
                <th>Riesgo obtenido</th>
              </tr>
            </thead>
            <tbody>
              {combinedValues.map((item, index) => (
                <tr key={index}>
                  <td>{item.factorRiesgo}</td>
                  <td>{item.variable}</td>
                  <td>{item.valorObtenido}</td>
                  <td className={styles.LealtadnumberSquare}>
                    <div
                      className={styles.LealtadnumberContainer}
                      style={{
                        backgroundColor: riskColors[item.riesgoObtenido],
                      }}
                    >
                      <p>{item.riesgoObtenido}</p>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
};

export default TableMDRCompany;
